import React, { useState } from "react";
import "../styles/PreferredPartner.css";

const PreferredPartner = () => {
  const [partners] = useState([
    {
      title: "PROFICIENT CUSTOMER SERVICE AGENTS",
      text: "AtEase Insurance is there for you with experienced customer service representatives that are always ready to help and answer whatever question youhave to ask and, werespond speedily.",
    },
    {
      id: 2,
      title: "NO HIDDEN CHARGES",
      text: "At ease insurance offers transparent services with no hidden charges! With our mobile tech solutions you can have access to your account details at anytime!",
    },
    {
      id: 3,
      title: "TOP-NOTCH SERVICES",
      text: "Also, as startups, we offer you top-notch services and bring you the best team to manage your funds so, be AtEase.",
    },
  ]);
  return (
    <div>
      <section className="partner__section">
        <div className="container ">
          <div className="row">
            <div className="faq-content">
              <h2
                className="h2-title"
                style={{ textAlign: "center", fontSize: "24px" }}
              >
                WHY ARE WE YOUR PREFERRED INSURANCE PARTNER
              </h2>
            </div>
          </div>
          <div className="row mt-3 mb-3">
            {partners.map((partner) => (
              <div className="col-md-4 p-2">
                <div className="card card-body shadow">
                  <div className="partner__content text-center p-3">
                    <h3 className="pt-2">{partner.title}</h3>
                    <p className="pt-2">{partner.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PreferredPartner;
